import { Component, EventEmitter, Output } from '@angular/core';
import { Afdeling } from '../../models/afdeling';
import { StatistikService } from '../../statistik.service';

@Component({
    selector: 'app-statistik-options-afdelinger',
    templateUrl: './statistik-options-afdelinger.component.html',
    standalone: false
})
export class StatistikOptionsAfdelingerComponent {
    @Output() selectAfdeling = new EventEmitter<number>();
    afdeling$ = this.statistikService.getAfdelinger();
    selectedAfdeling: string;

    constructor(
        private statistikService: StatistikService
    ) { }

    onSelectAfdeling(afdeling: Afdeling) {
        this.selectedAfdeling = afdeling?.afdelingsnavn;
        this.selectAfdeling.emit(afdeling?.id);
    }
}
